<template>
  <div>
    <div
      class="dimension-basic-toolbar basic-bar-position absolute z-100 left-1/2 bottom-10px bg-[#02173b] rounded-35px flex p-10px pl-20px pr-20px"
    >
      <div
        class="basic-bar-item w-25px h25px leading-25px text-center mr-20px cursor-pointer last:mr-0"
        v-for="(item, index) in basicTabBar"
        :key="index"
      >
        <template v-if="item.children">
          <el-popover placement="top" trigger="hover" popper-class="dimension-basicbar-popover">
            <div
              class="dimension-basic-toolbar bg-[#02173b] rounded-35px flex p-10px pl-20px pr-20px"
            >
              <div
                class="basic-bar-item w-25px h25px leading-25px text-center mr-20px cursor-pointer last:mr-0"
                v-for="(child, idx) in item.children"
                :key="idx"
              >
                <el-tooltip effect="dark" :content="child.name" placement="top">
                  <div
                    :class="{
                      'item-info':
                        selectChildTag.val === child.val || selectDialogChildTag.val === child.val,
                    }"
                  >
                    <span
                      @click="childBarHandle(item, child)"
                      class="iconfont text-20px text-white"
                      :class="child.iconName"
                    ></span>
                  </div>
                </el-tooltip>
              </div>
            </div>
            <div
              slot="reference"
              :class="{
                'item-info': selectTag.val === item.val || selectDialogTag.val === item.val,
              }"
            >
              <span class="iconfont text-20px text-white" :class="item.iconName"></span>
            </div>
          </el-popover>
        </template>
        <template v-else>
          <div v-if="item.val === '|'" class="-mt-2px">|</div>
          <el-tooltip v-else effect="dark" :content="item.name" placement="top">
            <div
              :class="{
                'item-info': selectTag.val === item.val || selectDialogTag.val === item.val,
              }"
            >
              <span
                @click="toolBarHandle(item)"
                class="iconfont text-20px text-white"
                :class="item.iconName"
              ></span>
            </div>
          </el-tooltip>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
const basicTabBar1 = [
  {
    name: '点选',
    val: 'system.Pickup',
    iconName: 'icon-yxr-clickSelect',
  },

  {
    name: '移动',
    val: 'system.Move',
    iconName: 'icon-yxr-move',
    children: [
      {
        name: '移动',
        val: 'system.Move',
        iconName: 'icon-yxr-move',
      },
      {
        name: '旋转',
        val: 'system.Rotate',
        iconName: 'icon-yxr-rotate',
      },
      {
        name: '缩放',
        val: 'system.Scale',
        iconName: 'icon-line-fullScreen',
      },
    ],
  },
  {
    name: '两点测量',
    val: 'M_Line',
    iconName: 'icon-yxr-twoPointMeasurement',
    children: [
      {
        name: '两点测量',
        val: 'M_Line',
        iconName: 'icon-yxr-twoPointMeasurement',
      },
      {
        name: '多点测量',
        val: 'M_Point',
        iconName: 'icon-yxr-multipointMeasurement',
      },
      {
        name: '高度测量',
        val: 'M_Vertical',
        iconName: 'icon-yxr-heightMeasurement',
      },
      {
        name: '立体测量',
        val: 'M_Stereo',
        iconName: 'icon-yxr-stereometry',
      },
      {
        name: '角度测量',
        val: 'M_Angel',
        iconName: 'icon-yxr-angleMeasurement',
      },
      {
        name: '面积测量',
        val: 'M_Area',
        iconName: 'icon-yxr-areaMeasurement',
      },
      {
        name: '轴距测量',
        val: 'M_WheelBase',
        iconName: 'icon-yxr-wheelbaseMeasurement',
      },
      {
        name: '清除测量结果',
        val: 'M_None',
        iconName: 'icon-bg-delete',
      },
    ],
  },
  {
    name: '隐藏',
    val: 'system.ToolHideModel',
    iconName: 'icon-yxr-hide',
    children: [
      {
        name: '隐藏',
        val: 'system.ToolHideModel',
        iconName: 'icon-yxr-hide',
      },
      {
        name: '显示上一个',
        val: 'system.ToolShowModel',
        iconName: 'icon-yxr-showPrevious',
      },
      {
        name: '显示所有已隐藏',
        val: 'system.ToolShowAll',
        iconName: 'icon-yxr-showAllHidden',
      },
    ],
  },
]

export default {
  name: 'basicToolBar',
  components: {},
  props: {
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
    cloudRender: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      basicTabBar: [],

      activeBar: '',
      activeChildBar: '',

      selectTag: '',
      selectChildTag: '',
      selectDialogTag: '',
      selectDialogChildTag: '',
      componentName: '',
      modelTreeProp: {
        currentNodeItem: 0, // 当前激活的node
        currentNodeName: '', // 点选时当前激活的节点名称
        treeData: [], // 模型树数据
        defaultCheckedKey: [], // 模型树选中的节点
        filterItem: [], // 模型树不需要显示的节点及他的父节点列表
        modelHideList: [], // 模型隐藏队列
      },
    }
  },
  methods: {
    toolBarHandle(item) {
      if (item.dialog) {
        if (this.selectDialogTag.val === item.val) {
          this.selectDialogTag = ''
        } else {
          this.selectDialogTag = item
        }
        this.$emit('basicToolbar', item)
        this.tagsClick(item)
      } else {
        if (this.selectTag.val === item.val) {
          this.selectTag = ''
        } else {
          this.selectTag = item
        }
        this.$emit('basicToolbar', this.selectTag)
        this.tagsClick(this.selectTag)
      }
      this.selectChildTag = ''
      this.selectDialogChildTag = ''
    },
    childBarHandle(parent, child) {
      const unActiveNode = [
        'system.ToolHideModelSpaceSwap',
        'system.ToolHideModel',
        'system.ToolShowModel',
        'system.ToolShowAll',
        'system.PickupCenter',
      ]

      if (unActiveNode.includes(child.val)) {
        this.tagsClick(child)
        return
      }
      if (child.dialog) {
        if (this.selectDialogChildTag.val === child.val) {
          this.selectDialogChildTag = ''
          this.selectDialogTag = ''
        } else {
          this.selectDialogChildTag = child
          this.selectDialogTag = parent
        }
        this.tagsClick(child)
      } else if (this.selectChildTag.val === child.val) {
        this.selectChildTag = ''
        this.selectTag = ''
        this.tagsClick(this.selectChildTag, child)
      } else {
        this.selectChildTag = child
        this.selectTag = parent
        this.tagsClick(this.selectChildTag)
      }
    },
    async tagsClick(tag, cancelTag) {
      // 显示隐藏
      const unActiveNode = [
        'system.ToolHideModelSpaceSwap',
        'system.ToolHideModel',
        'system.ToolShowModel',
        'system.ToolShowAll',
        'system.PickupCenter',
      ]
      if (unActiveNode.includes(tag.val)) {
        this.setModelVisible(tag.val)
        return
      }

      // 测量工具集合
      const measureList = {
        M_None: 0, // 清除测量结果
        M_Line: 1, // 两点测量
        M_Point: 2, // 多点测量
        M_Vertical: 3, // 高度测量
        M_Stereo: 4, // 立体测量
        M_Angel: 5, // 角度测量
        M_Area: 6, // 面积测量
        M_WheelBase: 7, // 轴距测量
      }
      if (_.keys(measureList).indexOf(tag.val) !== -1) {
        // 设置测量相关功能
        this.player.Native.Measure.setMeasureType(measureList[tag.val])
        if (tag.val === 'M_None') {
          // 如果是清除按钮
          this.player.Native.Measure.clearAll()
        }
      } else {
        // 清空测量工具
        this.player.Native.Measure.setMeasureType(0)
        this.player.Native.Measure.clearAll()
        this.player.Native.Tools.setCurrentTool(tag.val)
      }
    },
    // 控制模型中部件的显示隐藏
    async setModelVisible(status, isChecked = true, selectInfo = [], checkeds) {
      console.log('功能', status, isChecked, this.modelTreeProp)
      if (_.isEmpty(selectInfo)) {
        // 获取当前点选的对象
        selectInfo = await this.player.Native.Node.getSeletedNodes()
      }
      const itemList = _.map(this.modelTreeProp.modelHideList, (el) => {
        return el.node
      })
      // ###################
      const rootParent = await this.player.Native.Node.getRoot()
      const rootProperty = await this.player.Native.Node.getProperty(rootParent, ['children'])
      const rootNode = rootProperty.children[0]?.node
      // 删除地球GIS层
      const rootItemsList = [rootNode]
      switch (status) {
        case 'system.ToolShowModel':
          // 显示上一个(隐藏模型列表弹出最后一个，隐藏最后一个，默认框选中的列表添加弹出的最后一个)
          if (this.modelTreeProp.modelHideList.length > 0 && !this.modelTreeProp.spaceSwapStatus) {
            this.player.Native.Node.setProperty(
              this.modelTreeProp.modelHideList[this.modelTreeProp.modelHideList.length - 1].node,
              { visible: isChecked }
            )
            this.modelTreeProp.defaultCheckedKey.push(
              this.modelTreeProp.modelHideList[this.modelTreeProp.modelHideList.length - 1].node
            )
            this.modelTreeProp.filterItem.splice(
              this.modelTreeProp.filterItem.indexOf(
                this.modelTreeProp.modelHideList[this.modelTreeProp.modelHideList.length - 1].node
              ),
              1
            )
            this.modelTreeProp.modelHideList.pop()
          }
          break
        case 'system.ToolShowAll':
          // 显示全部隐藏（根据上面获取的跟节点之间都设置为true，清空隐藏模型列表，默认框选中的列表加上隐藏模型列表）
          this.player.Native.Node.setProperty(rootItemsList, { visible: isChecked })
          // 去重
          this.modelTreeProp.defaultCheckedKey = [
            ...new Set([...this.modelTreeProp.defaultCheckedKey, ...this.modelTreeProp.filterItem]),
          ]
          this.modelTreeProp.filterItem = []
          this.modelTreeProp.modelHideList = []
          this.modelTreeProp.spaceSwapStatus = false
          break
        case 'system.ToolHideModel':
          // 隐藏选中节点（把当前要隐藏的项添加到隐藏模型列表中，设置当前项隐藏状态，当前项以及其子孙节点都应该从默认框选中列表中除去）
          if (_.last(this.modelTreeProp.filterItem) === selectInfo[0]) return
          this.modelTreeProp.modelHideList.push({ node: selectInfo[0] })
          this.player.Native.Node.setProperty(selectInfo[0], { visible: false })
          this.modelTreeProp.filterItem.push(selectInfo[0])
          // 获取选中的selectInfo的父级selfId
          let parentInfo = await this.player.Native.Node.getProperty(selectInfo[0], ['parent'])
          this.modelTreeProp.filterItem.push(parentInfo.parent)
          // 如果不为最外层包裹层
          if (parentInfo.parent) {
            while (parentInfo.parent !== rootNode) {
              // eslint-disable-next-line no-await-in-loop
              parentInfo = await this.player.Native.Node.getProperty(parentInfo.parent, ['parent'])
              this.modelTreeProp.filterItem.push(parentInfo.node)
            }
          }
          const result = await this.player.Native.Node.getProperty(selectInfo[0], ['children'])
          const subItems = result.children
          // 去重放在报错之后，多push了几次进去
          this.modelTreeProp.filterItem = [
            ...new Set([
              ...this.modelTreeProp.filterItem,
              ..._.map(subItems, (res) => {
                return res.node
              }),
            ]),
          ]
          this.modelTreeProp.defaultCheckedKey = _.filter(
            this.modelTreeProp.defaultCheckedKey,
            (el) => {
              return this.modelTreeProp.filterItem.indexOf(el) === -1
            }
          )
          break
        case 'system.ToolHideModelSpaceSwap':
          // 空间交换
          // 隐藏模型，显示隐藏列表（将默认框选中的列表等于隐藏模型列表，上一次隐藏的全部显示）
          if (this.modelTreeProp.spaceSwapStatus) {
            this.modelTreeProp.defaultCheckedKey = _.map(this.modelTreeProp.modelHideList, (el) => {
              return el.node
            })
          } else {
            this.modelTreeProp.hiddenNodeKeys = _.map(this.modelTreeProp.modelHideList, (el) => {
              return el.node
            })
          }
          this.player.Native.Node.setProperty(rootItemsList, {
            visible: this.modelTreeProp.spaceSwapStatus,
          })
          this.player.Native.Node.setProperty(itemList, {
            visible: !this.modelTreeProp.spaceSwapStatus,
          })
          this.modelTreeProp.spaceSwapStatus = !this.modelTreeProp.spaceSwapStatus

          this.modelTreeProp.filterItem = _.filter(this.modelTreeProp.filterItem, (el) => {
            return this.modelTreeProp.hiddenNodeKeys.indexOf(el) === -1
          })
          this.modelTreeProp.filterItem = [
            ...new Set([...this.modelTreeProp.filterItem, ...this.modelTreeProp.defaultCheckedKey]),
          ]
          ;[this.modelTreeProp.defaultCheckedKey, this.modelTreeProp.hiddenNodeKeys] = [
            this.modelTreeProp.hiddenNodeKeys,
            this.modelTreeProp.defaultCheckedKey,
          ]
          break
        case 'checkModelTree':
          // 模型树显隐操作: 1、根据勾选情况设置当前勾选项的显隐 2、设置默认框选中列表
          // 3、如果是显示: 查找当前项是否在隐藏列表中，如果有就去掉当前项以及其子孙节点，默认框选中列表中需要添加当前项，如果该项的其他兄弟节点都为选中状态，那么其父辈节点也就要添加进去
          // 4、如果是隐藏：将当前项添加到隐藏模型列表中去，默认框选中列表除去当前项以及其子孙节点，还包括其父辈节点
          this.player.Native.Node.setProperty(selectInfo[0], { visible: isChecked })
          this.modelTreeProp.defaultCheckedKey = checkeds.checkedKeys
          if (isChecked) {
            const index = _.findIndex(this.modelTreeProp.modelHideList, ['node', selectInfo[0]])
            if (index !== -1) {
              this.modelTreeProp.modelHideList.splice(index, 1)
            }
            const index1 = this.modelTreeProp.filterItem.indexOf(selectInfo[0])
            if (index1 !== -1) {
              // 重新设置选中
              this.modelTreeProp.filterItem.splice(
                this.modelTreeProp.filterItem.indexOf(selectInfo[0]),
                1
              )
            }
          } else {
            this.modelTreeProp.modelHideList.push({ node: selectInfo[0] })
            this.modelTreeProp.filterItem.push(selectInfo[0])
            // 获取选中的selectInfo的父级selfId
            let ParentInfo = await this.player.Native.Node.getProperty(selectInfo[0], ['parent'])
            this.modelTreeProp.filterItem.push(ParentInfo.parent)
            if (ParentInfo.parent) {
              // 等于0则为最外面的一层
              while (ParentInfo.parent !== rootNode) {
                ParentInfo = await this.player.Native.Node.getProperty(ParentInfo.parent, [
                  'parent',
                ])
                this.modelTreeProp.filterItem.push(ParentInfo.node)
              }
            }
            this.modelTreeProp.filterItem = [...new Set(this.modelTreeProp.filterItem)]
          }
          break
        case 'system.ToolShowSingle':
          // 孤立查看
          if (selectInfo[0]) {
            if (this.modelTreeProp.spaceSwapStatus) {
              this.modelTreeProp.defaultCheckedKey = _.map(
                this.modelTreeProp.modelHideList,
                (el) => {
                  return el.node
                }
              )
            } else {
              this.modelTreeProp.modelHideList.push({ node: selectInfo[0] })
              this.modelTreeProp.filterItem.push(selectInfo[0])
              this.modelTreeProp.hiddenNodeKeys = _.map(this.modelTreeProp.modelHideList, (el) => {
                return el.node
              })
            }

            this.player.Native.Node.setProperty(rootItemsList, {
              visible: this.modelTreeProp.spaceSwapStatus,
            })
            this.player.Native.Node.setProperty(selectInfo[0], { visible: true })
            this.modelTreeProp.spaceSwapStatus = !this.modelTreeProp.spaceSwapStatus

            this.modelTreeProp.filterItem = _.filter(this.modelTreeProp.filterItem, (el) => {
              return this.modelTreeProp.hiddenNodeKeys.indexOf(el) === -1
            })
            this.modelTreeProp.filterItem = [
              ...new Set([
                ...this.modelTreeProp.filterItem,
                ...this.modelTreeProp.defaultCheckedKey,
              ]),
            ]
            ;[this.modelTreeProp.defaultCheckedKey, this.modelTreeProp.hiddenNodeKeys] = [
              this.modelTreeProp.hiddenNodeKeys,
              this.modelTreeProp.defaultCheckedKey,
            ]
          }
          break
        default:
          break
      }
    },
    closeActive() {
      this.selectDialogChildTag = ''
      this.selectDialogTag = ''
      this.componentName = ''
    },
  },
  created() {
    this.basicTabBar = [...basicTabBar1]
  },
}
</script>

<style lang="scss" scoped>
.basic-bar-position {
  transform: translateX(-50%);
}
.basic-bar-item {
  .item-info {
    .iconfont {
      color: #0784fa;
    }
  }
}
</style>

<style lang="scss">
.dimension-basicbar-popover {
  padding: 0;
  border: none;
  background: transparent;
}
</style>
